import { Component, inject } from '@angular/core';
import { PwaInstallService } from './pwa-install.service';

@Component({
  selector: 'app-install-app',
  standalone: true,
  template: `
    @if (!install.installed() && !install.promptDismissed()) {
      <div class="fixed right-4 bottom-[82px] md:bottom-5 z-[80] flex items-center rounded-xl bg-[#102C41] text-white shadow-lg border border-white/10 overflow-hidden">
        <button type="button" (click)="install.install()" class="h-10 pl-3 pr-2 flex items-center gap-2 text-xs font-bold hover:bg-[#1A6FA6]">
          <i class="ti ti-device-mobile-down text-[17px]"></i><span>Install Admin App</span>
        </button>
        <button type="button" (click)="install.dismissFloatingPrompt()" class="h-10 w-9 border-l border-white/10 text-white/70 hover:bg-white/10 hover:text-white" aria-label="Hide install prompt">
          <i class="ti ti-x text-[15px]"></i>
        </button>
      </div>
    }
    @if (install.instructionsOpen()) {
      <div class="fixed inset-0 z-[200] bg-slate-950/45 backdrop-blur-sm p-4 flex items-center justify-center" (click)="install.closeInstructions()">
        <section class="w-full max-w-sm rounded-2xl bg-white border border-slate-200 shadow-2xl overflow-hidden" (click)="$event.stopPropagation()">
          <div class="p-5 border-b border-slate-100 flex items-start justify-between gap-3"><div><p class="text-[10px] font-bold uppercase tracking-widest text-[#1A6FA6]">NZ Plumbing</p><h2 class="text-lg font-semibold text-slate-950 mt-1">Install Admin App</h2></div><button (click)="install.closeInstructions()" class="w-8 h-8 rounded-lg bg-slate-100 text-slate-500"><i class="ti ti-x"></i></button></div>
          <div class="p-5 text-sm text-slate-600 leading-relaxed">
            @if (install.isIos) { <p>In Safari, tap <strong>Share</strong> <i class="ti ti-share-2"></i>, then choose <strong>Add to Home Screen</strong> and confirm.</p> }
            @else if (install.isAndroid) { <p>Open your browser menu <strong>⋮</strong>, choose <strong>Install app</strong> or <strong>Add to Home screen</strong>, then confirm.</p> }
            @else { <p>Open your browser menu and choose <strong>Install NZ Plumbing Admin</strong>. In Chrome or Edge, the install icon may also appear at the right of the address bar.</p> }
            <div class="mt-4 rounded-xl bg-sky-50 border border-sky-100 p-3 text-xs text-sky-800">After installation it opens in its own window and stays available from your desktop or home screen.</div>
          </div>
        </section>
      </div>
    }
    @if (install.transitionTutorialOpen()) {
      <div class="fixed inset-0 z-[210] bg-slate-950/45 backdrop-blur-sm p-4 flex items-center justify-center" (click)="install.closeTransitionTutorial()">
        <section class="w-full max-w-md rounded-2xl bg-white border border-slate-200 shadow-2xl overflow-hidden" (click)="$event.stopPropagation()">
          <div class="p-5 border-b border-slate-100 flex items-start justify-between gap-3">
            <div>
              <p class="text-[10px] font-bold uppercase tracking-widest text-[#1A6FA6]">Install option moved</p>
              <h2 class="text-lg font-semibold text-slate-950 mt-1">Use the profile menu next time</h2>
            </div>
            <button type="button" (click)="install.closeTransitionTutorial()" class="w-8 h-8 rounded-lg bg-slate-100 text-slate-500 hover:bg-slate-200" aria-label="Close install tutorial">
              <i class="ti ti-x"></i>
            </button>
          </div>
          <div class="p-5 text-sm text-slate-600 leading-relaxed">
            <div class="grid gap-3">
              <div class="flex gap-3">
                <span class="w-8 h-8 rounded-lg bg-[#EAF5FA] text-[#1A6FA6] flex items-center justify-center shrink-0 font-bold text-xs">1</span>
                <p>Open the profile menu from your initials in the top-right corner.</p>
              </div>
              <div class="flex gap-3">
                <span class="w-8 h-8 rounded-lg bg-[#EAF5FA] text-[#1A6FA6] flex items-center justify-center shrink-0 font-bold text-xs">2</span>
                <p>Choose <strong>Install Admin App</strong> whenever you want the app on this device.</p>
              </div>
            </div>
            <button type="button" (click)="install.closeTransitionTutorial()" class="mt-5 h-10 w-full rounded-lg bg-[#0C3A5A] text-white text-xs font-bold hover:bg-[#082d46]">Got it</button>
          </div>
        </section>
      </div>
    }
  `
})
export class InstallAppComponent { install = inject(PwaInstallService); }
